<span
  placement="right"
  class="product-description"
  [ngbTooltip]="productDescriptionTooltip"
  tooltipClass="custom-tooltip fees-tooltip"
>
  {{ product.productDescription }}
</span>

<ng-template #productDescriptionTooltip>
  <div class="tooltip-content">
    <p><strong>Product Description</strong></p>
    <div>A delayed start mortgage postpones initial payments, however the interest is added to the loan</div>
  </div>
</ng-template>
